import React, { useState,useEffect } from "react";
import { X } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { CreateTeam } from "../../services/operations/authAPI";
import { updateTeam } from "../../services/operations/teamAPI";
import Loader from '../../Loader/Loader'

const AddTeam = ({ onClose ,prefilledEmail='',listTeam,isEditMode = false, editMember = null }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: prefilledEmail || "",
    roles: [],
  });
  const [emailError, setEmailError] = useState(""); 
  const [nameError, setNameError] = useState("");
  const dispatch=useDispatch()
  const token=useSelector((state)=>state.auth.token)
  const loading=useSelector((state)=>state.auth.loading)


  const resetForm = () => {
    setFormData({
      name: "",
      email: prefilledEmail || "",
      roles: [],
    });
    setEmailError("");
    setNameError("");
  };

  useEffect(() => {
    if (isEditMode && editMember) {
      // Edit mode: fill with member details
      setFormData({
        name: editMember.name,
        email: editMember.email,
        roles: editMember.roles,
      });
    } else {
      resetForm();
    }
  }, [isEditMode, editMember, prefilledEmail]);

 
  useEffect(() => {
    return () => resetForm();  
  }, []);
  const isFormValid = formData.name && formData.email && formData.roles.length > 0 && !emailError && !nameError;

  const validateEmail = (email) => {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
  };

  const validateName = (name) => {
    const namePattern = /^[A-Za-z\s]+$/;   
    return namePattern.test(name);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }))
    if (name === "email") {
      setEmailError(validateEmail(value) ? "" : "Invalid email format");
    }

    if (name === "name") {
      setNameError(validateName(value) ? "" : "Name must contain only alphabets and spaces");
    }
  };

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      roles: checked
        ? [...prev.roles, value]
        : prev.roles.filter((role) => role !== value),
    }));
  };

  const handleSubmit=async()=>{
    if (isEditMode && editMember) {
      const payload={
        status:"",
        roles:formData.roles
      }
       await dispatch(updateTeam(payload,token,editMember.id,onClose));
    } 
    else {
      const payload={
        name:formData.name,
      email:formData.email,
      roles:formData.roles
      }
      await dispatch(CreateTeam(payload, token, onClose));
    }
    listTeam();
    resetForm();   
  }

  return (
    <div className="popup-overlay">
      {loading && <Loader/>}
      <div className="popup-content">
        <div className="popup-header">
          <p style={{color:"rgba(0, 0, 0, 0.7)",fontWeight:"600",fontSize:"24px"}}>  {isEditMode ? "Edit Member" : "Invite Member"}</p>
         
          <X className="close-icon" onClick={() => {
            resetForm();  
            onClose();
          }} />
        </div>
        <p style={{color:"rgba(119, 124, 129, 1)",fontWeight:"400",fontSize:"12px",marginBottom:"25px"}}>       
             {isEditMode ? "Fill up the following details to edit members to your dashboard": "Fill up the following details to invite members to your dashboard"}
</p>

        <div className="input-group-invite">
          <div className="form-group-invite">
          <label className="popup-label">Name</label>
          <input
            type="text"
            name="name"
            className="popup-input"
            value={formData.name}
            onChange={handleInputChange}
            disabled={isEditMode}
          />
          {nameError && <p className="error-message" style={{margin:"0px"}}>{nameError}</p>}
          </div>
          <div className="form-group-invite">
            <label className="popup-label">Email Address</label>
            <input
              type="email"
              name="email"
              className="popup-input"
              value={formData.email}
              onChange={handleInputChange}
              disabled={isEditMode}
            />
            {emailError && <p className='error-message' style={{margin:"0px"}}>{emailError}</p>}
          </div>
        </div>
        <p style={{fontWeight:"600",fontSize:"12px",color:"rgba(0, 0, 0, 0.7)"}}>Select Position:</p>
        <div className="checkbox-group">
          <label>
            <input
              type="checkbox"
              value="hiring-manager"
              onChange={handleCheckboxChange}
              checked={formData.roles.includes("hiring-manager")}
            />
            Hiring Manager
          </label>
          <label>
            <input
              type="checkbox"
              value="recruiter"
              onChange={handleCheckboxChange}
              checked={formData.roles.includes("recruiter")}
            />
            Recruiter
          </label>
          <label>
            <input
              type="checkbox"
              value="team-member"
              onChange={handleCheckboxChange}
              checked={formData.roles.includes("team-member")}
            />
            Team Member
          </label>
        </div>
        <div className="popup-actions">
          <button className="submit-btn" disabled={!isFormValid} onClick={handleSubmit}>
          {isEditMode ? "Update" : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddTeam;
